import { render, staticRenderFns } from "./AccountLogin.vue?vue&type=template&id=33fa02b6&scoped=true"
import script from "./AccountLogin.vue?vue&type=script&lang=ts"
export * from "./AccountLogin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fa02b6",
  null
  
)

export default component.exports